import useModal from 'lib/hooks/useModal';

import Popover from 'components/shared/Popovers/Popover/Popover';
import ReceiptModal from 'components/shared/Receipt/ReceiptModal';

import RefundAdminModal from './RefundAdminModal';

export const Actions = ({ data }) => {
  const {
    isOpen: isRefundModalOpen,
    openModal: openRefundModal,
    closeModal: closeRefundModal
  } = useModal();

  const {
    isOpen: isReceiptModalOpen,
    openModal: openReceiptModal,
    closeModal: closeReceiptModal
  } = useModal();

  const isRefundable =
    ['completed', 'partially_refunded'].includes(data?.status?.toLowerCase()) && !data?.isPatient;

  const actionsOptions = [
    {
      label: 'View receipt',
      icon: 'eye-mono',
      onClick: openReceiptModal
    },
    ...(isRefundable
      ? [
          {
            label: 'Refund',
            icon: 'money-send-mono',
            onClick: openRefundModal
          }
        ]
      : [])
  ];

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={actionsOptions}
        isBorder={false}
      />
      {isReceiptModalOpen && (
        <ReceiptModal
          transactionId={data?.id}
          isOpen={isReceiptModalOpen}
          onClose={closeReceiptModal}
        />
      )}
      {!!isRefundModalOpen && (
        <RefundAdminModal
          isOpen={isRefundModalOpen}
          onClose={closeRefundModal}
          transaction={data}
        />
      )}
    </>
  );
};

export default Actions;
